import { Skeleton } from '@faceup/ui-base'

type Props = {
  variant?: 'small' | 'large'
}

const FieldSkeleton = () => (
  <div className='flex flex-col gap-2'>
    <Skeleton.Input size='small' className='w-[100px]' />
    <Skeleton.Input block />
  </div>
)

export const AF_FormSkeleton = ({ variant = 'small' }: Props) => (
  <div className='flex flex-col gap-6'>
    <FieldSkeleton />
    {variant === 'large' && (
      <>
        <FieldSkeleton />
        <FieldSkeleton />
        <FieldSkeleton />
      </>
    )}
    <Skeleton.Button block />
  </div>
)
